<script setup>
import BgLogin from '../../../images/bg-login-left.png'
</script>

<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 m-auto w-full">
    <div>
      <img :src="BgLogin" alt="" class="w-full hidden sm:block max-h-[650px]" />
    </div>
    <div class="bg-[#1C2833]">
      <form
        method="post"
        enctype="multipart/form-data"
        action="/dang-nhap"
        class="h-full flex flex-col justify-center it gap-4 px-5 py-5 sm:px-10"
      >
        <h2
          class="text-white font-medium text-3xl text-center mb-3 font-[Inder]"
        >
          Đăng nhập
        </h2>

        <div class="w-full">
          <div class="input-group">
            <label
              for="username"
              class="text-white font-normal text-xl text-center font-[Inder]"
              >Tên tài khoản</label
            >
            <input
              id="username"
              class="w-full mt-2 rounded font-normal text-base bg-white tracking-[-1%] text-black placeholder:text-black placeholder:opacity-75"
              name="username"
              placeholder="Nhập Tên Tài khoản "
              required
            />
          </div>
        </div>
        <div class="w-full">
          <div class="input-group">
            <label
              for="password"
              class="text-white font-normal text-xl text-center font-[Inder]"
              >Mật khẩu</label
            >
            <input
              type="password"
              id="password"
              class="w-full mt-2 rounded font-normal text-base bg-white tracking-[-1%] text-black placeholder:text-black placeholder:opacity-75"
              name="password"
              placeholder="Nhập mật khẩu "
              required
            />
          </div>
        </div>
        <div class="flex items-center" style="margin: 10px 0px 10px 0px">
          <input class="form-check-input" type="checkbox" id="CheckDefault" />
          <label
            class="ms-2 text-white font-normal text-xl tracking-[-1%]"
            for="CheckDefault font-[Inder]"
            >Nhớ tài khoản
          </label>
        </div>

        <div class="flex justify-center mb-1">
          <button
            class="bg-[#B03A2E] py-2 px-5 text-3xl font-normal text-white rounded"
            name="dangnhap"
            type="submit font-[Inder]"
          >
            Đăng nhập
          </button>
        </div>
        <slot></slot>
      </form>
    </div>
  </div>
</template>
